var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoTimeOut = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stopwatch",
    transform: "translate(-42.432)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28329",
    "data-name": "Group 28329",
    transform: "translate(48.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28328",
    "data-name": "Group 28328"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47372",
    "data-name": "Path 47372",
    d: "M191.935,0V1.585h1.6v.792a5.416,5.416,0,0,1,1.6,0V1.585h1.6V0Z",
    transform: "translate(-191.935)",
    fill: "#74276b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28331",
    "data-name": "Group 28331",
    transform: "translate(42.432 1.823)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28330",
    "data-name": "Group 28330"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47373",
    "data-name": "Path 47373",
    d: "M55.88,52.475l.56-.555.64.634,1.12-1.109-2.4-2.377-1.12,1.109.64.634-.72.713a8.009,8.009,0,0,0-11.041,2.694A7.966,7.966,0,0,0,57.24,62.381,7.777,7.777,0,0,0,55.88,52.475ZM50.439,63.807a5.548,5.548,0,1,1,0-11.095V58.26h5.6A5.54,5.54,0,0,1,50.439,63.807Z",
    transform: "translate(-42.432 -49.067)",
    fill: "#74276b"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoTimeOut);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_time_out.41b5a827a98b2bdf648e1de0aca8a780.svg";